module.exports = __webpack_public_path__ + "static/media/cover@3x.44ea4cef.png";